import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Rocket, Heart, X, ArrowUpRight } from "lucide-react";

const CONTEST_URL =
  "https://app.emergent.sh/showcase/builderfest-kevin/561e6428-e616-4317-8e62-6c802c73c066?ref=dala516698&utm_source=share";
const STORAGE_KEY = "invesy_builderfest_prompt_v1";

export default function ContestPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const vote = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    window.open(CONTEST_URL, "_blank", "noopener,noreferrer");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/60 backdrop-blur-sm"
          onClick={dismiss}
          data-testid="contest-popup"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 8 }}
            transition={{ type: "spring", stiffness: 260, damping: 24 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-3xl bg-slate-900 border border-white/10 p-8 text-center shadow-2xl"
          >
            <button
              onClick={dismiss}
              data-testid="contest-close"
              className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors duration-200"
              aria-label="Close"
            >
              <X size={22} />
            </button>

            <div className="h-16 w-16 rounded-2xl bg-indigo-500/15 border border-indigo-400/20 flex items-center justify-center mx-auto mb-6">
              <Rocket size={28} className="text-indigo-300" />
            </div>

            <h2 className="font-heading font-bold text-2xl text-white tracking-tight">
              Enjoying Invesy?
            </h2>
            <p className="text-slate-300 mt-3 leading-relaxed">
              Invesy is competing in the <span className="font-semibold text-white">Emergent Builder Fest</span>.
              If this felt useful, a quick upvote means the world — it helps us keep building for investors everywhere. 🙏
            </p>

            <button
              onClick={vote}
              data-testid="contest-vote-btn"
              className="mt-7 w-full h-14 rounded-2xl bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-lg flex items-center justify-center gap-2.5 transition-colors duration-200"
            >
              <Heart size={20} className="fill-white" /> Support us at the Builder Fest
              <ArrowUpRight size={20} />
            </button>

            <button
              onClick={dismiss}
              data-testid="contest-later-btn"
              className="mt-4 text-sm text-slate-400 hover:text-slate-200 transition-colors duration-200"
            >
              Maybe later
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
